import React from 'react'
import BaseIcon from 'react-icon-base'

const Done = props => (
  <BaseIcon width="20" height="20" viewBox="0 0 20 20" {...props}>
    <g>
      <path
        fill="#FF9800"
        fillRule="evenodd"
        d="M14 4H6v2H4V4H2v4h16V4h-2v2h-2V4zm2-2h4v18H0V2h4V0h2v2h8V0h2v2zm2 8H2v8h16v-8zM4 12h2v2H4v-2z"
      />
    </g>
  </BaseIcon>
)

export default Done
